<template>
  <div class="material-info" v-if="imgData">
    <el-dialog title="素材编辑" :visible.sync="isShow" width="300px" center destroy-on-close class="">
      <div class=""><img class=" w-100" :src="imgData.url" :alt="imgData.title" :title="imgData.title"></div>
      <div class=" mt-3 d-flex align-items-center " >
        <div class=" width-40 me-2">名称</div>
        <el-input
          placeholder="请输入内容"
          v-model="imgData.title"
          size="small"
          style="flex:1;"
          clearable>
        </el-input>
      </div>
      <div class=" mt-3 d-flex align-items-center ">
        <div class=" width-40 me-2">分类</div>
        <el-select v-model="imgData.category" placeholder="请选择" size="small">
          <el-option
            v-for="item in typeList"
            :key="item.index"
            :label="item.title"
            :value="item.id"
            v-if="item.id >= 0"
          >
          <div class=" d-flex align-items-center">
            <div style="flex:1;">{{item.title}}</div>
          </div>
          </el-option>
        </el-select>
      </div>
      <div class="mt-4 text-center">
        <el-button type="primary" @click="onSubmit" size="small">保存</el-button>
        <el-button type="" @click="isShow = false" size="small">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import MaterialDepositoryService from '../../service/MaterialDepository.service.js'
export default {
  props: {
    typeList: {
      type: Array,
      default: [],
    },
  },
  data () {
    return {
      isShow: false,
      imgData: null
    }
  },
  methods: {
    open(item) {
      this.imgData = JSON.parse(JSON.stringify(item))
      this.isShow = true
    },
    onSubmit () {
      MaterialDepositoryService.edit(this.imgData).then(res => {
        this.$message.success("保存成功！");
        this.isShow = false
        this.$emit('onConfirm')
      })
    }
  }
}
</script>
<style scoped>
  .width-40{
    width: 40px;
    text-align-last: justify;
  }
  :deep(.el-dialog__body){
    padding-top: 0;
  }
</style>